module.exports = __webpack_public_path__ + "static/media/2.32c9a9ee.png";